import { Modal, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

interface IProps {
  waitingModalVisible: boolean,
  setWaitingModalVisible: any
}

export const WaitingModal = (props: IProps) => {
  const { waitingModalVisible, setWaitingModalVisible } = props
  const antIcon = <LoadingOutlined style={{ fontSize: 32 }} spin />

  return (
    <Modal
      title="Téléchargement"
      centered
      visible={waitingModalVisible}
      keyboard={false}
      footer={null}
      onOk={() => setWaitingModalVisible(false)}
      onCancel={() => setWaitingModalVisible(false)}
      maskClosable={false}
      bodyStyle={{ textAlign: 'center' }}
    >
      <Spin indicator={antIcon} style={{ color: '#1576e1', margin: 'auto', width: '100%' }} />
      <br /><br />
      <p>Veuillez ne pas fermer cette fenêtre, votre téléchargement démarrera automatiquement.</p>
    </Modal>
  )
}
